import axios from 'axios'

import { Comment } from 'common/server/comment'
import { OrderMaterial } from 'common/server/orders'
import { File, OrderStates, OrderSubStates } from 'common/server/server_types'
import { Flags } from 'common/server/user'

import { Delivery, DeliveryUpdateParams } from 'vendor/server/deliveries'

export interface Order {
  updated_at: string
  comments: Comment[]
  company_material_columns: string[]
  confirmed_at: string
  quote_scheduled_to_expire_at?: string
  deliveries: Delivery[]
  id: string
  order_materials: OrderMaterial[]
  order_number: string
  order_package_name: string
  project: { name: string; tax_line_items: { enabled: boolean } }
  public_purchaser_files: File[]
  state: OrderStates
  sub_state: OrderSubStates
  commitment: {
    id: string
    name: string
    number: string
  }
  user: {
    id: string
    full_name: string
    company_name: string
  }
  company_vendor: {
    id: string
    vendor_name: string
    vendor?: {
      id: string
      name: string
      default_quote_valid_for_days: number
    }
  }
  vendor_contacts: {
    id: string
    first_name: string
    last_name: string
    email: string
    vendor_user?: {
      id: string
      first_name: string
      last_name: string
      email: string
      invitation_accepted: boolean
      invitation_expires_at: Date
      invitation_link: string
    }
  }[]
  vendor_files: File[]
  purchase_order?: File
  quote?: File[]
  cancellation_rejected_at?: string
  cancellation_accepted_at?: string
  cancellation_requested_at?: string
  cancellation_requested_reason?: string

  // Not part of the order model, but we need to know which feature flag user have
  feature_flags: Flags
  vendor_price_lock_enabled: boolean
}

export interface OrderUpdateParams {
  id: string
  updated_at: string
  state_changes?: { confirmed_at?: string; rejected_at?: string }
  order_materials?: OrderMaterial[]
  vendor_files_signed_ids?: string[]
  vendor_files_delete_ids?: string[]
  quote_signed_id?: string
  comment?: string
  deliveries?: DeliveryUpdateParams[]
}

export function show(id: string) {
  return axios.get<Order>(`/vendors/order/${id}`)
}

export function update(payload: OrderUpdateParams) {
  return axios.patch(`/vendors/order/${payload['id']}`, payload)
}

export function comment(id: string, payload: { comment: string; company_vendor_contact_id: string }) {
  return axios.post(`/vendors/order/${id}/comment`, payload)
}
